import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { goBack, push } from "connected-react-router";
import { Policies } from "../../../../../utils/Policies";
import { Utils } from "../../../../../utils";
import ROUTES from "../../../../../routes";
import {
  BoxSeparator,
  ContentBox,
  Page,
  TitleBox,
  ForbiddenSection,
  Button,
  Box,
} from "../../../../../components";
import { Language } from "../../../../../utils";
import { Grid, TextField, InputAdornment } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Publish as UploadIcon, InfoOutlined } from "@material-ui/icons";
import clsx from "clsx";
import makeClasses from "./styles";
import { business as businessActions } from "../../../../../actions";

const AddChargeScreen = ({ match }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();
  const { languageTexts } = useSelector((state) => ({
    languageTexts: state.language.texts || {},
    branchesWithNoPaymentMethod:
      state.business.branchesWithNoPaymentMethod || [],
  }));
  const [forbiddenSection, setForbbidenSection] = useState(false);
  const i18n = Language(languageTexts);
  const { policies } = useSelector((state) => ({
    policies: state.user.userData.policies || [],
    branches: state.business.branches || [],
    userData: state.user.userData || null,
  }));
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const uploadInputRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (
      !policies ||
      !policies.includes(Policies.types.PROVIDER_CREATE_PAYMENT)
    ) {
      setForbbidenSection(true);
    }
  }, [policies]);

  const handleOnFileUpload = (e) => {
    setFile(e.currentTarget.files);
  };

  const _goBack = (e) => {
    e.preventDefault();
    dispatch(goBack());
  };

  const _handleFileNameOnChange = (e) =>
    setFileName(e.target.value.substring(0, 100));

  const _downloadTemplate = (e) => {
    e.preventDefault();
    dispatch(
      businessActions.downloadAddChargeTemplate((file) => {
        Utils.downloadFile(file, "Plantilla_Solicitudes_Cobro.xlsx");
      })
    );
  };

  const _submitForm = (e) => {
    e.preventDefault();
    dispatch(
      businessActions.uploadProviderChargeFile(file, fileName, (response) => {
        dispatch(push(ROUTES.MANAGE_PROVIDERS_CHARGES.path + "?uploadSuccess=true"));
      })
    );
  };

  const renderAddChargeForm = () => {
    return (
      <Grid container justify="center" alignItems="center" spacing={4}>
        <Grid item xs={12} sm={12} md={6}>
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            label={i18n.get("ProvidersManageChargesAdd.FileNameInputLabel")}
            placeholder={i18n.get(
              "ProvidersManageChargesAdd.FileNameInputPlaceholder"
            )}
            className={classes.fileNameInput}
            onChange={_handleFileNameOnChange}
            value={fileName}
            InputProps={{
              endAdornment:
                fileName.length > 0 ? (
                  <InputAdornment position="start">
                    <span className={classes.fileNameInputEndAdornment}>
                      {fileName.length} / 100
                    </span>
                  </InputAdornment>
                ) : null,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <div className={classes.inputFile}>
            <input
              ref={uploadInputRef}
              id="file"
              type="file"
              accept=".xlsm,.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={handleOnFileUpload}
            />
            <label htmlFor="file">
              <div>{i18n.get("ProvidersManageChargesAdd.FileInputLabel")}</div>
              {!file
                ? i18n.get("ProvidersManageChargesAdd.FileInputPlaceholder")
                : file?.[0]?.name}
              <div className={classes.inputFileIcon}>
                <UploadIcon fontSize="small" />
              </div>
            </label>
          </div>
        </Grid>
      </Grid>
    );
  };

  if (forbiddenSection) {
    return (
      <Page
        withHeader
        withSidebar
        withHeaderTitle={i18n.get("ProvidersManageChargesAdd.Title")}
        withActivePage={ROUTES.MANAGE_PROVIDERS_CHARGES_ADD.id}>
        <ForbiddenSection />
      </Page>
    );
  }

  return (
    <Page
      withHeader
      withSidebar
      withHeaderTitle={i18n.get("ProvidersManageChargesAdd.Title")}
      withActivePage={ROUTES.MANAGE_PROVIDERS_CHARGES_ADD.id}
      showBranchWithNoPaymentMethodWarning={false}>
      <TitleBox
        title={i18n.get("ProvidersManageChargesAdd.Title")}
        back
        backTitle={i18n.get("ProvidersManageChargesAdd.BoxBackButton")}
        onBackClick={_goBack}
        backButtonVariant="outlined"
      />
      <BoxSeparator />
      <Box direction="column">
        <ContentBox
          title={i18n.get("ProvidersManageChargesAdd.BoxTitle")}
          titleBold
          padding={false}
          showShadow={false}>
          <div className={classes.contentBox}>
            {renderAddChargeForm()}
            <Alert
              severity="info"
              icon={false}
              className={clsx(classes.alert, classes.alertInfo)}>
              <div>
                <InfoOutlined className={classes.alertIcon} />
              </div>
              <div className={classes.alertMessage}>
                <AlertTitle className={classes.alertTitle}>
                  {i18n.get("ProvidersManageChargesAdd.InformativeTextTitle")}
                </AlertTitle>
                {i18n.get("ProvidersManageChargesAdd.InformativeTextMessage")}{" "}
                <button
                  className={classes.downloadLink}
                  onClick={_downloadTemplate}
                  target="_blank">
                  {i18n.get(
                    "ProvidersManageChargesAdd.InformativeTextMessageLink"
                  )}
                </button>
              </div>
            </Alert>
          </div>
        </ContentBox>
        <div className={classes.formSeparator} />
        <div>
          <div className={classes.contentActionsWrapper}>
            <Button variant="outlined" onClick={_goBack}>
              {i18n.get(
                "ProvidersSubscriptionsAddTermsAndConditions.CancelButton"
              )}
            </Button>
            <div className={classes.contentActionSeparator} />
            <Button onClick={_submitForm} disabled={!file || !fileName}>
              {i18n.get(
                "ProvidersSubscriptionsAddTermsAndConditions.SaveButton"
              )}
            </Button>
          </div>
        </div>
      </Box>
    </Page>
  );
};

AddChargeScreen.id = "com.Handy.AddCharge";

export default AddChargeScreen;
